import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const taskPriority = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/task/{profile}/task-priority',
    app: 'task',
    pk: 'id'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'task', model: 'task-priority' }
    ),
    { }
  )
)()

export { taskPriority, TYPES }
